/* ADVELLO — mobile swipeable product gallery.

   Deliberately standalone: it does not patch theme.js, it observes it.
   theme.js already marks the correct thumbnail .is-active whenever the
   variant or the gallery changes, so watching that class is enough to know
   which slide should be showing — no coupling to its internals.

   Pairs with advello-mobile-gallery.css, which lays the slides out as a
   scroll-snap carousel below 761px and overrides theme.js's [hidden]. */
(function () {
  "use strict";

  var MOBILE = typeof window.matchMedia === "function"
    ? window.matchMedia("(max-width: 760px)")
    : null;

  function isMobile() {
    return !!(MOBILE && MOBILE.matches);
  }

  function slidesOf(frame) {
    return Array.prototype.slice.call(frame.querySelectorAll("[data-gallery-slide]"));
  }

  function centredSlide(frame) {
    var slides = slidesOf(frame);
    if (!slides.length) return null;
    var centre = frame.scrollLeft + frame.clientWidth / 2;
    var closest = slides[0];
    var best = Infinity;
    slides.forEach(function (slide) {
      var middle = slide.offsetLeft - frame.offsetLeft + slide.clientWidth / 2;
      var distance = Math.abs(middle - centre);
      if (distance < best) { best = distance; closest = slide; }
    });
    return closest;
  }

  function setup(gallery) {
    if (gallery.dataset.advSwipeReady === "true") return;
    var frame = gallery.querySelector(".product-main-frame");
    if (!frame) return;
    gallery.dataset.advSwipeReady = "true";

    var thumbs = gallery.querySelector(".product-gallery-thumbs");
    var slides = slidesOf(frame);

    var counter = null;
    if (slides.length > 1) {
      counter = document.createElement("p");
      counter.className = "adv-gallery-counter";
      counter.setAttribute("aria-hidden", "true");
      (thumbs || frame).parentNode.insertBefore(counter, thumbs || frame.nextSibling);
    }

    var selfScrolling = false;
    var selfScrollTimer = null;

    function scrollTo(slide, smooth) {
      if (!slide) return;
      selfScrolling = true;
      if (selfScrollTimer) window.clearTimeout(selfScrollTimer);
      var left = slide.offsetLeft - frame.offsetLeft;
      if (typeof frame.scrollTo === "function") {
        frame.scrollTo({ left: left, behavior: smooth ? "smooth" : "auto" });
      } else {
        frame.scrollLeft = left;
      }
      selfScrollTimer = window.setTimeout(function () { selfScrolling = false; }, smooth ? 450 : 60);
    }

    function paint(slide) {
      if (!slide) return;
      if (counter) {
        var position = slidesOf(frame).indexOf(slide) + 1;
        counter.textContent = position ? position + " / " + slides.length : "";
      }
      if (!thumbs) return;
      var id = slide.dataset.mediaId;
      Array.prototype.forEach.call(thumbs.querySelectorAll("[data-gallery-thumb]"), function (thumb) {
        var active = thumb.dataset.mediaId === id;
        thumb.classList.toggle("is-active", active);
        thumb.setAttribute("aria-pressed", active ? "true" : "false");
        if (active && thumbs.scrollWidth > thumbs.clientWidth && typeof thumbs.scrollTo === "function") {
          thumbs.scrollTo({
            left: thumb.offsetLeft - (thumbs.clientWidth - thumb.clientWidth) / 2,
            behavior: "smooth"
          });
        }
      });
    }

    // The customer swiping is the source of truth: update the thumbs to match,
    // never the other way round, or the carousel snaps back under their finger.
    var settle = null;
    frame.addEventListener("scroll", function () {
      if (!isMobile() || selfScrolling) return;
      if (settle) window.clearTimeout(settle);
      settle = window.setTimeout(function () { paint(centredSlide(frame)); }, 90);
    }, { passive: true });

    // theme.js flips .is-active on the thumbs when a variant is picked or a
    // thumbnail is tapped. Follow it, and bring the carousel along.
    if (thumbs && typeof window.MutationObserver === "function") {
      var observer = new MutationObserver(function () {
        if (!isMobile() || selfScrolling) return;
        var active = thumbs.querySelector("[data-gallery-thumb].is-active");
        if (!active) return;
        var slide = frame.querySelector('[data-gallery-slide][data-media-id="' + active.dataset.mediaId + '"]');
        if (!slide) return;
        if (slide === centredSlide(frame)) return;
        scrollTo(slide, true);
        if (counter) {
          var position = slidesOf(frame).indexOf(slide) + 1;
          counter.textContent = position ? position + " / " + slides.length : "";
        }
      });
      Array.prototype.forEach.call(thumbs.querySelectorAll("[data-gallery-thumb]"), function (thumb) {
        observer.observe(thumb, { attributes: true, attributeFilter: ["class"] });
      });
    }

    function sync() {
      if (!isMobile()) return;
      var active = thumbs && thumbs.querySelector("[data-gallery-thumb].is-active");
      var slide = active
        ? frame.querySelector('[data-gallery-slide][data-media-id="' + active.dataset.mediaId + '"]')
        : slidesOf(frame)[0];
      scrollTo(slide, false);
      paint(slide);
    }

    // Images load lazily, so offsetLeft is only trustworthy once they have size.
    if (document.readyState === "complete") sync();
    else window.addEventListener("load", sync);
    sync();

    if (MOBILE) {
      var onChange = function () { window.setTimeout(sync, 50); };
      if (typeof MOBILE.addEventListener === "function") MOBILE.addEventListener("change", onChange);
      else if (typeof MOBILE.addListener === "function") MOBILE.addListener(onChange);
    }
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll(".product-gallery"), setup);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  // Theme editor re-renders sections without a page load.
  document.addEventListener("shopify:section:load", init);
})();
